import {FmlxIcon} from 'fmlx-common-ui';
import PropTypes from 'prop-types';
import React, {useMemo} from 'react';

import style from './InputFileHint.module.scss';

const Variant = {
  INFO: 'info',
  WARNING: 'warning',
  DANGER: 'danger',
};

function InputFileHint({id, caption, variant}) {
  const getColor = useMemo(() => {
    switch (variant) {
      case Variant.INFO:
        return '#0059cc';
      case Variant.WARNING:
        return '#F7A246';
      case Variant.DANGER:
        return '#FF0000';
      default:
        return '#5C5C5C';
    }
  }, [variant]);

  const getIconName = useMemo(() => {
    switch (variant) {
      case Variant.INFO:
        return 'Info';
      case Variant.WARNING:
        return 'Warning';
      case Variant.DANGER:
        return 'Error';
      default:
        return '';
    }
  }, [variant]);

  return (
    <div id={id} className={style.container}>
      <div className={style.icon}>
        {getIconName && <FmlxIcon name={getIconName} size={FmlxIcon.Size.EXTRA_SMALL} customColor={getColor} />}
      </div>
      <div style={{color: getColor}} className={style.caption}>
        {caption}
      </div>
    </div>
  );
}

InputFileHint.Variant = Variant;

InputFileHint.propTypes = {
  caption: PropTypes.node,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.oneOf([...Object.values(Variant), '']),
};

InputFileHint.defaultProps = {
  caption: '',
  id: 'input-file-hint',
  variant: '',
};

export default InputFileHint;
